import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homebtn',
  templateUrl: './homebtn.component.html',
  styleUrls: ['./homebtn.component.scss']
})
export class HomebtnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
